import { Component, inject } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { AccountDataService } from '../../account-data.service';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../../../modules/material.module';
import { AuthService } from '../../../../authentication/auth.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-reauth-dialog',
  standalone: true,
  imports: [MaterialModule, FormsModule],
  templateUrl: './reauth-dialog.component.html',
})
export class ReauthDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<ReauthDialogComponent>);
  private auth = inject(AuthService);
  private readonly ac = inject(AccountDataService);
  private readonly router = inject(Router);

  txtPassword = '';

  private onClose(): void {
    this.dialogRef.close();
  }

  /**
   * deletes this user's account after reauthenticating the current user in firebase (necessary for performing sensitive account actions)
   */
  reauthThenDeleteUserAccount(): void {
    let self = this;

    this.auth
      .reauthUser(this.txtPassword)
      .then(function () {
        if (environment.debuggingConsoleLogsOn) {
          console.log('User successfully reauthenticated.');
        }
        self.ac
          .deleteUserAccountInFirebase()
          .then(function () {
            if (environment.debuggingConsoleLogsOn) {
              console.log('Account deleted in firebase');
            }
            self.onClose();
            self.router.navigate(['home']); // and navigate to homepage
          })
          .catch(function (error) {
            console.log(error);
          });
      })
      .catch(function (error) {
        console.log(error);
      });
  }
}
